import { createAction } from '@reduxjs/toolkit';

export const removeComp = createAction<string>('removeComp');
export const removeComps = createAction<{
  ids: string[];
  sequenceTarget?: 'compSequence' | 'rentalCompSequence';
}>('removeComps');
